import React from "react";
import { Box, Paper } from "@mui/material";
import { COLORS } from "../../assets/theme";
import { useFeatures } from "../../contexts/FeaturesContext";
import FeatureLockedContent from "./FeatureLockedContent";

/**
 * Guards a route behind a feature switch. The backend 403s these paths anyway;
 * this turns that into the upsell panel rather than a half-broken screen — and
 * it also covers a tab that was already open when the switch was flipped.
 */
const FeatureRoute: React.FC<{
  feature: string;
  children: React.ReactNode;
}> = ({ feature, children }) => {
  const { isEnabled } = useFeatures();

  if (isEnabled(feature)) {
    return <>{children}</>;
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", p: { xs: 2, sm: 4 } }}>
      <Paper
        elevation={0}
        sx={{
          maxWidth: 520,
          width: "100%",
          p: 3,
          borderRadius: 3,
          border: `1px solid ${COLORS.BorderColor}`,
          bgcolor: COLORS.WhiteBackground,
        }}
      >
        <FeatureLockedContent feature={feature} />
      </Paper>
    </Box>
  );
};

export default FeatureRoute;
